export const STAFF_PATH = '/staff';

/** Pestañas de Keenvil Staff; `check` dice que servicio confirma el acceso. */
export const STAFF_TABS = [
  { key: 'HELP', title: 'Ayuda / Preguntas frecuentes', check: 'help' },
  { key: 'FINES', title: 'Multas', check: 'fines' },
  // Last: altas y bajas de comunidades are not an everyday task.
  { key: 'COMMUNITIES', title: 'Comunidades', check: 'communities' }
];

/** Pestañas visibles segun lo que confirmo cada servicio. */
export const visibleTabs = access =>
  STAFF_TABS.filter(tab => !!(access && access[tab.check]));

/** La pestaña pedida si esta visible; si no, la primera visible. */
export const resolveTab = (requested, tabs) => {
  if (!tabs.length) {
    return null;
  }
  const match = tabs.find(tab => tab.key === requested);
  return (match || tabs[0]).key;
};
